export const PeriodisationRowFormValue = {
  Amount: "amount" as const,
  Range: "range" as const,
}

export const PeriodisationRowsFormValue = {
  Mode: "mode" as const,
  IsSplit: "isSplit" as const,
  Rows: "rows" as const,
}

export const Details = {
  SupplierName: "supplierName" as const,
  SupplierOrgNr: "supplierOrgNr" as const,
  Account: "account" as const,
  ReferencePerson: "referencePerson" as const,
  Vat: "vat" as const,
  Amount: "amount" as const,
  Currency: "currency" as const,
  InvoiceDate: "invoiceDate" as const,
  DueDate: "dueDate" as const,
  Bg: "bg" as const,
  Ocr: "ocr" as const,
  IsAlreadyPaid: "isAlreadyPaid" as const,
  PaymentDate: "paymentDate" as const,
  PaymentTerms: "paymentTerms" as const,
  PaymentStatus: "paymentStatus" as const,
  IsCredit: "isCredit" as const,
  Dimensions: "dimensions" as const,
  Periodisation: "periodisation" as const,
  AllowPeriodisation: "allowPeriodisation" as const,
  AdditionalInfoAttachments: "additionalInfoAttachments" as const,
  AdditionalInfoComment: "additionalInfoComment" as const,
  Iban: "iban" as const,
  Bic: "bic" as const,
  IsInternationalPaymentDetailsAccepted: "isInternationalPaymentDetailsAccepted" as const,
  Street: "street" as const,
  Street2: "street2" as const,
  City: "city" as const,
  ZipCode: "zipCode" as const,
  Country: "country" as const,
}

export const Filter = {
  InvoiceDate: "invoiceDate" as const,
  DueDate: "dueDate" as const,
  PaymentDate: "paymentDate" as const,
  SnapshotDate: "snapshotDate" as const,
  InvoiceNumber: "invoiceNumber" as const,
  Amount: "amount" as const,
  PaymentStatuses: "paymentStatuses" as const,
  State: "state" as const,
  Dimensions: "dimensions" as const,
  IsSnapShot: "isSnapShot" as const,
  AgentIncomingInvoicesId: "agentIncomingInvoicesId" as const,
  Suppliers: "suppliers" as const,
  Receivers: "receivers" as const,
  BookingAccounts: "bookingAccounts" as const,
}

export const Todo = {
  Account: "account" as const,
  AccountSuggestions: "accountSuggestions" as const,
  Dimensions: "dimensions" as const,
  Periodisation: "periodisation" as const,
  AllowPeriodisation: "allowPeriodisation" as const,
  ShowDimensions: "showDimensions" as const,
  ShowAccount: "showAccount" as const,
  AdditionalInfoAttachments: "additionalInfoAttachments" as const,
  AdditionalInfoComment: "additionalInfoComment" as const,
  IsAlreadyPaid: "isAlreadyPaid" as const,
  CreditPaymentHandling: "creditPaymentHandling" as const,
  PaymentHandlingInformation: "paymentHandlingInformation" as const,
  Iban: "iban" as const,
  Bic: "bic" as const,
  Street: "street" as const,
  Street2: "street2" as const,
  City: "city" as const,
  ZipCode: "zipCode" as const,
  Country: "country" as const,
}

export const OverPaidAgingInvoiceTodo = {
  Action: "action" as const,
  Explanation: "explanation" as const,
  Files: "files" as const,
}

export const UnderPaidAgingInvoiceTodo = {
  Action: "action" as const,
  Explanation: "explanation" as const,
  PaymentDate: "paymentDate" as const,
  PlannedPaymentDate: "plannedPaymentDate" as const,
  PaymentNumber: "paymentNumber" as const,
}

export const SendBack = {
  Email: "email" as const,
  Subject: "subject" as const,
  Message: "message" as const,
}

export const UpdatePayment = {
  IsAlreadyPaid: "isAlreadyPaid" as const,
  PaymentDate: "paymentDate" as const,
}

